import React from 'react';
import CustomInputIfc from '../../../lib/FormValidator/Form/CustomInputIfc';
import InputField from '../../../lib/FormValidator/Form/InputField';
import MessageCourier from '../../../lib/MessageCourier';
import SystemClient from '../../../system/SystemClient';
import RegistroEntrenadorForm from '../../RegistroEntrenador/RegistroEntrenadorForm';
import { ProvinciaSelectorInput } from '../../Provincia/ProvinciaSelector';
import { Text } from '@fluentui/react';
import { validateEmail, validatePhone } from '../WizardRegistroEntrenador';


interface IContacto {
  form: RegistroEntrenadorForm;
  onBlurCustomInput: (customInput: CustomInputIfc) => void;
  system: SystemClient;
  courier: MessageCourier;
}

export const Contacto = ({form, onBlurCustomInput, system, courier}: IContacto) => {
  // const [disableInputs, setDisableInputs] = React.useState(!(!email && !telefono));
  // const url = React.useMemo(() => {
  //   if (props.fileSelfie) {
  //     const url = URL.createObjectURL(props.fileSelfie!);
  //     return url;
  //   }
  //   return '';
  // }, [props.fileSelfie]);



  return (
    <div>
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 form-item">
            <InputField input={form.getEmailInput()} label="Email (*)" onBlur={onBlurCustomInput} />
          </div>
          {form.getEmailInput().getValue() &&
            !validateEmail(form.getEmailInput().getValue()) && (
              <div className="ms-Grid-col ms-sm12 form-item mt-1">
                <Text className="ms-TextField-errorMessage" styles={{ root: { color: 'red' } }}>
                  El email provisto no es válido
                </Text>
              </div>
            )}
        </div>

        <div className="ms-Grid-row mt-2">
          <div className="ms-Grid-col ms-sm12 form-item">
            <InputField input={form.getTelMovilInput()} label="Teléfono" onBlur={onBlurCustomInput} propsInput={{ type: 'number', inputMode: 'numeric' }}/>
          </div>
          {form.getTelMovilInput().getValue() &&
            !validatePhone(form.getTelMovilInput().getValue()) && (
              <div className="ms-Grid-col ms-sm12 form-item mt-1">
                <Text className="ms-TextField-errorMessage" styles={{ root: { color: 'red' } }}>
                  El teléfono no debe incluir símbolos, sólo números
                </Text>
              </div>
            )}
        </div>

        <div className="ms-Grid-row mt-2">
          <div className="ms-Grid-col ms-sm12 form-item">
            <InputField input={form.getDomicilioInput()} label="Domicilio" onBlur={onBlurCustomInput} />
          </div>
        </div>

        <div className="ms-Grid-row mt-2">
          <div className="ms-Grid-col ms-sm12 form-item">
            <InputField input={form.getLocalidadInput()} label="Localidad" onBlur={onBlurCustomInput} />
          </div>
        </div>

        <div className="ms-Grid-row mt-2">
          <div className="ms-Grid-col ms-sm6 form-item">
            {/* TODO: AGREGAR DROPDOWN PROVINCIAS */}
            {/* <InputField input={form.getProidInput()} label="Provincia" onBlur={onBlurCustomInput} /> */}
            <ProvinciaSelectorInput
              system={system}
              courier={courier}
              input={form.getProidInput()}
              onBlurCustomInput={onBlurCustomInput}
            />
          </div>
          <div className="ms-Grid-col ms-sm6 form-item">
            <InputField input={form.getCodPostalInput()} label="C.P." onBlur={onBlurCustomInput} />
          </div>
        </div>

        <div className="ms-Grid-row mt-2">
          {/* <div className="ms-Grid-col ms-sm6 form-item">
            <InputField input={form.getTelFijoInput()} label="Tel. Fijo" onBlur={onBlurCustomInput} />
          </div> */}
          {/* <div className="ms-Grid-col ms-sm12 form-item">
            <InputField input={form.getEmailAdicionalInput()} label="Email 2" onBlur={onBlurCustomInput} />
          </div> */}
        </div>
      </div>
      {/* <div>
        <Label>Email</Label>
        <TextField
          // disabled={disableInputs}
          value={props.email}
          onChange={(e, nv) => props.setEmail(nv ? nv : '')}
          type="email"
          required
          description="Te vamos a notificar a este email"
        />
      </div>
      <div>
        <Label>Telefono</Label>
        <TextField
          disabled={disableInputs}
          value={props.telefono}
          onChange={(e, nv) => props.setTelefono(nv ? nv : '')}
          type="tel"
        />
      </div>
      <div style={{ minHeight: 20 }}>
        <Text
          variant="small"
          className="float-right mt-1 link-styles"
          onClick={() => (disableInputs ? setDisableInputs(false) : null)}
        >
          Editar
        </Text>
      </div> */}
    </div>
  );
};
